/** Only allows in-app relative paths as post-login destinations (prevents open redirects). */
export function safeReturnTo(value: string | null): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\'))
    return '/dashboard';
  return value;
}
